import { rc } from "./rc";

export const employee_positivity = {
  rc,
};
